export default {
	nbOfFiles: 'fichier | fichiers',
	headers: [
		{
			text: 'Nom du fichier',
			align: 'left',
			sortable: true,
			value: 'originalFileName'
		},
		{
			text: 'Date de dépôt',
			align: 'left',
			sortable: true,
			value: 'createdAt',
			cellType: 'date'
		},
		{
			text: 'Date du dernier téléchargement',
			align: 'left',
			value: 'lastDownloadedAt',
			cellType: 'date'
		},
		{
			text: '',
			align: 'right',
			sortable: false,
			value: 'download'
		}
	]
};
